import './heading.scss';
import type { HeadingProps } from "./Heading.interface";

/**
 * Primary UI component for user interaction
 */
export function Heading (props:HeadingProps) {
    
    switch (props.type) {
        case "h1":
            return ( <h1 aria-label={props.id} id={props.id} className={props.className} style={props.style}>{props.text}</h1>);
        case "h2":
            return ( <h2 aria-label={props.id} id={props.id} className={props.className} style={props.style}>{props.text}</h2>);
        case "h3":
            return ( <h3 aria-label={props.id} id={props.id} className={props.className} style={props.style}>{props.text}</h3>);
        case "h4":
            return ( <h4 aria-label={props.id} id={props.id} className={props.className} style={props.style}>{props.text}</h4>);
        case "h5":
            return ( <h5 aria-label={props.id} id={props.id} className={props.className} style={props.style}>{props.text}</h5>);
        case "h6":
            return ( <h6 aria-label={props.id} id={props.id} className={props.className} style={props.style}>{props.text}</h6>);
    }
}